import { render, staticRenderFns } from "./UserPermissionConfirmationDialog.vue?vue&type=template&id=01bb3366"
import script from "./UserPermissionConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./UserPermissionConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports